export default {
  alert: {
    message: {
      content: "",
      type: ""
    },
    show: false
  },
  modal: {
    id: "",
    show: false
  },
  savingUser: false,
  userToDelete: "",
  users: [],
  allUsers: [],
  user: {},
  auth: {
    isLoading: false,
    username: "",
    user: {},
    roles: null,
    maxRole: null,
    isAuth: false,
    isAdmin: false,
    isBrowser: false,
    resetSent: false
  },
  file: "",
  customers: [],
  customer: {},
  savingCustomer: false,
  customerToDelete: "",
  contacts: [],
  contractsByCustomer: [],
  contact: {},
  savingContact: false,
  customerContactToDelete: "",
  labels: [],
  label: {},
  savingLabel: false,
  labelToDelete: "",
  licenses: [],
  license: {},
  savingLicense: false,
  licenseToDelete: "",
  departments: [],
  department: {},
  roles: [],
  role: {},
  savingRole: false,
  roleToDelete: "",
  locations: [],
  location: {},
  savingLocation: false,
  customerLocationToDelete: "",
  customerNoteToDelete: "",
  services: [],
  service: {},
  savingService: false,
  serviceToDelete: "",
  codes: [],
  code: {},
  savingCode: false,
  codeToDelete: "",
  companies: [],
  company: {},
  savingCompany: false,
  companyToDelete: "",
  chargetypes: [],
  chargetype: {},
  savingChargetype: false,
  chargetypeToDelete: "",
  contracts: [],
  contract: {},
  loadingContract: false,
  savingContract: false,
  contractToDelete: "",
  contractPOToDelete: "",
  contractNoteToDelete: "",
  calls: [],
  range: [],
  call: {},
  savingCall: false,
  callToSave: {},
  callToDelete: "",
  callsToApprove: [],
  partToDelete: "",
  recurringCalls: [],
  callCount: "",
  recurrence: {},
  supportTicket: {},
  supportTickets: [],
  supportTicketsBoard: [],
  savingSupportTicket: false,
  supportTicketToDelete: "",
  invoices: [],
  invoice: {},
  savingInvoice: false,
  invoiceToDelete: "",
  invoicesToApprove: [],
  invoicesToComplete: [],
  projects: [],
  paginatedProjects: {
    data: [],
    pages: 0,
    total: 0
  },
  project: {},
  savingProject: false,
  projectToDelete: "",
  projectTaskToDelete: "",
  projectNoteToDelete: "",
  projectAttachmentToDelete: "",
  projectNotificationToDelete: "",
  expenses: [],
  expense: {},
  savingExpense: false,
  expenseToDelete: "",
  expenseReceiptToDelete: "",
  budgets: [],
  ptoRequests: [],
  ptoRequest: {},
  savingPtoRequest: false,
  ptoRequestToDelete: "",
  loading: false,
  contractTiers: [],
  contractTier: null,
  savingContractTier: false,
  tasks: [],
  task: {},
  savingTask: false,
  report: [],
  ptoBalance: null,
  departmentCategories: [],
  departmentCategory: {},
  resource_summary: [],
  DPSReport: {
    topProjects: [],
    calls: [],
    totals: {
      actualHours: 0,
      billableHours: 0
    },
    departmentCategories: []
  },
  PESReport: {
    users: [],
    calls: []
  },
  exporting: false,
  exported: null,
  resource_summary_report: [],
  itmsContracts: [],
  callApprovalToNotify: {},
  ptoRequestReceiptToDelete: {},
  DCCReport: [],
  OSTReport: [],
  PSAReport: [],
  inProgressCustomerProjects: {
    result: [],
    count: 0
  },
  withSupportResourcesProjects: {
    result: [],
    count: 0
  },
  taxCodes: []
};
